import { render, staticRenderFns } from "./show-descriptor-disclaimer.vue?vue&type=template&id=553c77ae&"
import script from "./show-descriptor-disclaimer.vue?vue&type=script&lang=js&"
export * from "./show-descriptor-disclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports